"use client";
import { useSearchParams } from "next/navigation";
import { CircleMinus, CirclePlus } from "@/icons";
import React, { useState } from "react";
import { Reveal } from "../revealPageItems";

interface FaqItem {
  id: number;
  title: string;
  description: string;
  category: string;
}

interface Faq0Props {
  faqItems: FaqItem[];
}

const Faq0: React.FC<Faq0Props> = ({ faqItems }) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  const toggleExpand = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const searchParams = useSearchParams();
  const selectedCategory = searchParams.get("category") || "Todos";

  const filteredFaqItems =
    selectedCategory === "Todos"
      ? faqItems
      : faqItems.filter((item) => item.category === selectedCategory);

  return (
    <div className="mx-auto w-full max-w-[1216px]">
      {filteredFaqItems.map((item, index) => (
        <div key={index} className="w-full border-b py-8">
          <Reveal>
            <div
              className="flex w-full cursor-pointer flex-row items-center justify-between"
              onClick={() => toggleExpand(index)}
              onKeyUp={() => {}}
            >
              <h2 className="faq-title w-full pb-2 text-2xl leading-relaxed">
                {item.title}
              </h2>
              <div className="ml-4 flex-shrink-0">
                {expandedIndex === index ? <CircleMinus /> : <CirclePlus />}
              </div>
            </div>
          </Reveal>
          {/* ✅ Agora o conteúdo sempre estará renderizado no HTML */}
          <div
            className={`faq-content ${expandedIndex === index ? "open" : ""}`}
          >
            <p className="w-[80%] pt-4 leading-relaxed md:w-[60%]">
              {item.description}
            </p>
          </div>
        </div>
      ))}

      {/* ✅ Estilização via CSS, sem desmontar o conteúdo */}
      <style jsx>{`
        .faq-content {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
        }

        .faq-content.open {
          max-height: 500px; /* Ajuste conforme necessário */
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default Faq0;
